/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2023, Zumper
 * @description constants
 */

// regex
export const BATHROOMS_RE = /bathrooms/
export const BEDROOMS_RE = /(\d[+-])beds?|((?:(?:studios?|\d),){1,4}\d[+-])beds?/
export const CITY_STATE_HOOD_RE = /^\w[-\w.']+-[a-z]{2}\/[\w.'][-\w.']+$/i
export const CITY_STATE_RE = /^\w[-\w.']+-[a-z]{2}$/i
export const DETAIL_RE = /(?:a|b|p)?\d+/
export const DIGITS_RE = /^[0-9]+$/
export const FILTERS_START_RE =
  /\/(?:furnished|short-term|low-income|move-in-special|no-security-deposit|utilities-included|luxury|cheap|no-fee|income-restricted|senior-living|student-housing|on-site-laundry|deals-only|parking|outdoor-space|pets-allowed|pet-friendly|dog-friendly|cat-friendly|today|over-\d+|under-\d+|price[-,:]?[\d,]+(?:[,-][\d,]+?)?|nightly-over-\d+|nightly-under-\d+|nightly-price[-,:]?[\d,]+(?:[,-][\d,]+?)?|studios?\+?|\d[+-]beds?|(?:(?:studios?|\d),){1,4}\d[+-]beds?)(?:\/|\?|$)/
export const LUXURY_RE = /cheap|luxury/
export const NEAR_UNIVERSITY_RE = /\/near(.*)(college|university)(.*)+-[a-z]{2}/
export const NIGHTLY_OVER_RE = /nightly-over-(\d+)/
export const NIGHTLY_PRICE_RANGE_RE = /nightly-price[-,:]?([,\d]+)(?:[,-]([\d,]+))?/
export const NIGHTLY_UNDER_RE = /nightly-under-(\d+)/
export const OVER_RE = /over-(\d+)/
export const PRICE_RANGE_RE = /price[-,:]?([,\d]+)(?:[,-]([\d,]+))?/
export const PROPERTY_TYPE_PATH_RE = /(?:apartments|condos|houses|rooms)-for-rent/
export const STATE_RE = /^[a-z]{2}$/i
export const STUDIO_RE = /studios?(\+)?(?![-,+s\d])/
export const UNDER_RE = /under-(\d+)/

// end of regex

export const APARTMENTS = 'apartments'
export const CONDOS = 'condos'
export const HOUSES = 'houses'
export const ROOMS = 'rooms'
export const PROPERTY_TYPES = [APARTMENTS, CONDOS, HOUSES, ROOMS]

export const CONDOS_BASE_URL = 'condos-for-rent'
export const HOUSES_BASE_URL = 'houses-for-rent'
export const ROOMS_BASE_URL = 'rooms-for-rent'
